export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5601.e9a73f73.jpg";